const MosaicTypes = [
  {
    label: '2 linhas na primeira coluna',
    value: 'first_line',
  },
  {
    label: '2 linhas na segunda coluna',
    value: 'second_line',
  },
];

export default MosaicTypes;
